import PlatformTypeMixin from "@/mixins/PlatformTypeMixin";
import nativeMethodDispatcher from "@/utils/nativeMethodDispatcher";
import platformType from "@/utils/platformType";

export default {
  mixins: [ PlatformTypeMixin ],
  methods: {
    logout() {
      if (platformType.isIos() || platformType.isAndroid()) {
        nativeMethodDispatcher.dispatch('logout').then(() => {
          localStorage.clear();
        });
      } else {
        this.$router.push({ name: 'home' }).then(() => {
          localStorage.clear();
        });
      }
    }
  }
}
